// @flow

// URLs starting with http://, https://, or ftp://
const URL_PATTERN = /(\bhttps?:\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim

// URLs starting with "www." (without // before it, or it'd re-link the ones done above).
const PSEUDO_URL_PATTERN = /(^|[^/])(www\.[\S]+(\b|$))/gim

// Change email addresses to mailto:: links.
const EMAIL_ADDRESS_PATTERN = /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim

const ANCHOR_TAG_PATTERN = /<a[^>]*>([^<]+)<\/a>/g

function isValidUrl (url: string): boolean {
  try {
    // eslint-disable-next-line no-new
    new URL(url)
    return true
  } catch (e) {
    return false
  }
}

// Dominik; 02.02.2023; potentially there's a better way to track links without being vulnerable for xss attacks
export function onclickFunction (url: string, messageId?: number): string {
  if (messageId && isValidUrl(url) && Number.isInteger(messageId)) {
    return `window.chatchamp.trackLink('${url}', ${messageId}); return true;`
  } else {
    return 'return true;'
  }
}

/**
 * This method takes urls and transfers them to links
 */
export function linkify (inputText: string, messageId?: number): string {
  // global RegExp maintains state (!!!)
  ANCHOR_TAG_PATTERN.lastIndex = 0
  if (ANCHOR_TAG_PATTERN.test(inputText)) return inputText

  return inputText.replace(URL_PATTERN, (match, p1) => {
    return `<a href="${p1}" target="_blank" onclick="${onclickFunction(p1, messageId)}">${p1}</a>`
  })
    .replace(PSEUDO_URL_PATTERN, (match, p1, p2) => {
      return `${p1}<a href="http://${p2}" target="_blank" onclick="${onclickFunction(`http://${p2}`, messageId)}">${p2}</a>`
    })
    .replace(EMAIL_ADDRESS_PATTERN, '<a href="mailto:$1">$1</a>')
}
